import { debugLogger } from './debugLogger';

export interface ViaCepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  erro?: boolean;
}

// Cache simples em memória
const cepCache = new Map<string, ViaCepResponse>();

export const fetchAddressByCep = async (cep: string): Promise<ViaCepResponse | null> => {
  try {
    const cleanCep = cep.replace(/\D/g, '');
    
    if (cleanCep.length !== 8) {
      return null;
    }

    // Verificar cache primeiro
    if (cepCache.has(cleanCep)) {
      debugLogger.debug('[CEP] Using cached address for:', cleanCep);
      return cepCache.get(cleanCep)!;
    }

    debugLogger.debug('[CEP] Fetching address from API for:', cleanCep);
    
    const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
    
    if (!response.ok) {
      throw new Error('Failed to fetch CEP');
    }
    
    const data: ViaCepResponse = await response.json();
    
    if (data.erro) {
      debugLogger.warn('[CEP] CEP not found:', cleanCep);
      return null;
    }
    
    // Armazenar no cache
    cepCache.set(cleanCep, data);
    debugLogger.info('[CEP] Address found and cached:', data);
    
    return data;
    
  } catch (error) {
    debugLogger.error('[CEP] Error fetching address:', error);
    return null;
  }
};

export const formatCep = (value: string): string => {
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 5) {
    return numbers;
  }
  return `${numbers.slice(0, 5)}-${numbers.slice(5, 8)}`;
};

export const formatPhone = (value: string): string => {
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 2) {
    return numbers;
  }
  if (numbers.length <= 6) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
  }
  if (numbers.length <= 10) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
  }
  return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
};
